import React from 'react';
import MemberDetailsCard from './MemberDetailsCard';

const PERSONAL_COLUMNS = [
  { field: 'Title', header: 'Title' },
  { field: 'First_Name', header: 'First name' },
  { field: 'Surname', header: 'Last name' },
  { field: 'Initials', header: 'Initials' },
  { field: 'ID_Number', header: 'ID number' },
  { field: 'Home_Tel', header: 'Phone' },
];

const CONTACT_COLUMNS = [
  { field: 'Gender', header: 'Gender' },
  { field: 'Marital_Status', header: 'Marital Status' },
  { field: 'Date_Of_Birth', header: 'Date Of Birth' },
  { field: 'Region', header: 'Nationality' },
  { field: 'EmailAddress', header: 'Email' },
  { field: 'Address', header: 'Physical and Postal Address' },
];

const ViewMainMemberTable = ({ activeUserData }) => (
  <MemberDetailsCard
    title="MAIN MEMBER DETAILS"
    sections={[
      { value: [activeUserData.mainMember], columns: PERSONAL_COLUMNS, emptyMessage: 'No member set' },
      { value: [activeUserData.mainMember], columns: CONTACT_COLUMNS, emptyMessage: 'No Users found' },
    ]}
  />
);

export default ViewMainMemberTable;
